import React from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
import { NotFoundTrans } from "../../utils/translations";

export default function NotFound() {
  const { language } = useAppContext();
  const t = NotFoundTrans[language] || NotFoundTrans.english;

  return (
    <main className="min-h-[80vh] flex flex-col items-center justify-center px-6 py-16 bg-lightBeige">
      <div className="max-w-lg w-full text-center">
        {/* Decorative 404 */}
        <div className="relative mb-8">
          <span className="text-[8rem] sm:text-[10rem] font-serif text-brown/10 select-none leading-none block">
            404
          </span>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-4xl sm:text-5xl text-brown/30 font-medium tracking-widest">
              404
            </span>
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl font-semibold text-brown mb-3">
          {t.title}
        </h1>
        <p className="text-grey text-base sm:text-lg mb-10 max-w-sm mx-auto">
          {t.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="w-full sm:w-auto px-8 py-3 rounded-full border-2 border-brown text-brown font-medium hover:bg-brown/5 transition-colors"
          >
            {t.backHome}
          </Link>
        </div>

        {/* Soft yoga mat illustration hint */}
        <div className="mt-16 pt-8 border-t border-brown/10">
          <p className="text-sm text-grey/80">
            Once up on a mat — yoga doesn't take time, it gives time.
          </p>
        </div>
      </div>
    </main>
  );
}
